import {Action, Module, Mutation, VuexModule} from 'vuex-module-decorators';
import {Inject} from 'inversify-props';
import * as logfmt from 'logfmt';

import {UserLog, UserLogService} from '@/model/system/log/UserLog';

import {ISystemLogService} from '@/services/system/ILog.service';

@Module({name: 'SystemLogStore', namespaced: true})
export default class SystemLogStore extends VuexModule {
  private userLogs: UserLog[] = [];
  private userLogsServices: UserLogService[] = [];

  @Inject(Symbol.for('ISystemLogService'))
  private logService!: ISystemLogService;

  @Action({commit: 'setUserLogs', rawError: true})
  public async fetchUserLogs(): Promise<UserLog[]> {

    const newUserLogs: UserLog[] = [];
    const newServices: UserLogService[] = [];

    const userLogs = await this.logService.getUserLog();

    const serviceRegex = /^(?<name>[a-zA-Z-_./]+)(?:\[(?<uid>\d+)\])?: /i;

    if (!userLogs) {
      return [];
    }

    let i = 0;
    for (const log of userLogs) {

      const userLog = new UserLog();

      userLog.Id = i++;
      userLog.Original = log.content;

      /* Tag */
      const tag = log.tag.split('.');
      userLog.Category = tag[0];
      userLog.Level = tag[1];

      /* Timestamp */
      userLog.Time = new Date(log.timestamp);

      /* Service */
      const match = log.content.match(serviceRegex);
      if (match !== null) {

        const service = match.groups;
        if (service !== undefined) {
          userLog.Service = new UserLogService(service.name, service.uid);

          if (newServices.filter((s) => s.Name === service.name).length === 0) {
            newServices.push(userLog.Service);
          }
        }

        log.content = log.content.replace(serviceRegex, '');
      }

      const content = logfmt.parse(log.content) as any;

      /* Message */
      if (content.msg !== undefined) {
        userLog.Message = content.msg;
        userLog.Fields = content;
      } else {
        userLog.Message = log.content;
      }

      newUserLogs.push(userLog);
    }

    this.context.commit('setUserLogsServices', newServices);

    return newUserLogs;
  }

  @Mutation
  public setUserLogs(userLogs: UserLog[]) {
    this.userLogs = userLogs;
  }

  @Mutation
  public setUserLogsServices(services: UserLogService[]) {
    this.userLogsServices = services.sort((a, b) => a.Name.localeCompare(b.Name));
  }

  get UserLogs(): UserLog[] | null {
    return this.userLogs;
  }

  get UserLogsServices(): UserLogService[] | null {
    return this.userLogsServices;
  }
}
